import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "./ReportTemplate.css";

import { useReportContext } from "../../../../_context/ReportContext";
import {
  ReportHeader,
} from "./ReportTemplateComponents/ReportHeader";
import { ReportAreaView } from "./ReportTemplateComponents/ReportAreaView";
// import { ReportFalultReport } from "./ReportTemplateComponents/ReportFalultReport";
import { ReportRemarksView } from "./ReportTemplateComponents/ReportRemarksView";
import { ReportConfirmationView } from "./ReportTemplateComponents/ReportConfirmationView";
import ReportNDISQuestions from "./ReportTemplateComponents/ReportNDISQuestions";
import { PDFDownloadLink, BlobProvider } from "@react-pdf/renderer";
import { PDFReport } from "../../ReportToPDF/PDFReport";
import EmailSenderCleaners from "../../../../_aws/EmailSenderCleaners";
import EmailSenderClient from "../../../../_aws/EmailSenderClients";
import { saveReport } from "../../../../_utils/resourceAPI";
import SubmitReportSuccess from "../NotificationModals/SubmitReportSuccess";
import { useLocation } from "react-router-dom";

export const ReportViewLayout = () => {
  const { currentViewingReport } = useReportContext();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [isReportSaved, setIsReportSaved] = useState(false);
  const [enableEmailButtons, setEnableEmailButtons] = useState(false);
  const location = useLocation();

  const handleCloseSuccessModal = () => setShowSuccessModal(false);
  const handleCloseExitModal = () => setShowExitModal(false);
  const handleSubmit = async () => {
    try {
      await saveReport(currentViewingReport);
      setEnableEmailButtons(true);
      setIsReportSaved(true);
      setShowSuccessModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleExitReport = () => {
    // Show the exit confirmation modal
    setShowExitModal(true);
  };

  const handleClientEmailSent = () => {
    // Client email sent callback
  };

  const handleCleanerEmailSent = () => {
    // Cleaner email sent callback
  };

  const isInViewReports = location.pathname.includes(
    "reports/client_reports"
  );

  return (
    <Container fluid className="mt-4 mb-4">
      <Container>
        <ReportHeader client={currentViewingReport.Client} reportCreateDate={currentViewingReport.ReportedDate.toString()} totalScore={currentViewingReport.TotalScore.toString()} key="reportHeader" />
        <ReportAreaView Areas={currentViewingReport.Areas} key="areaView" />
        <ReportNDISQuestions />
        <ReportRemarksView ClientRemarks={currentViewingReport.ClientRemarks} CNARemarks={currentViewingReport.CNARemarks} />
        <ReportConfirmationView CNASignature={currentViewingReport.QASignature} ClientSignature={currentViewingReport.ClientSignature} ClientConsent={currentViewingReport.ClientConcent} />
      </Container>
      <hr />
      <div className="rp-bottom-nav" style={{ paddingTop: "24px", marginTop: "24px", borderTop: "1px solid #E5E7EB", gap: "12px", alignItems: "center" }}>
        {!isInViewReports && (
          <button
            className="rp-bottom-nav-btn hover-trigger"
            style={{ background: "linear-gradient(135deg, #10b981 0%, #059669 100%)", color: "white", border: "none", padding: "10px 20px", borderRadius: "8px", fontWeight: 600, boxShadow: "0 4px 12px rgba(16,185,129,0.2)" }}
            onClick={handleSubmit}
          >
            Save Report
          </button>
        )}
        <button
          className="rp-bottom-nav-btn hover-trigger"
          style={{ background: "#fff", color: "#EF4444", border: "1px solid #FCA5A5", padding: "10px 20px", borderRadius: "8px", fontWeight: 600 }}
          onClick={handleExitReport}
        >
          Exit Report
        </button>

        <BlobProvider document={<PDFReport currentViewingReport={currentViewingReport} />}>
          {({ blob, url, loading, error }) => (
            <>
              <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "center" }}>
                <EmailSenderCleaners
                  pdfBlob={blob}
                  isEnabled={enableEmailButtons || isInViewReports}
                  onEmailSent={handleCleanerEmailSent}
                />
                <EmailSenderClient
                  pdfBlob={blob}
                  isEnabled={enableEmailButtons || isInViewReports}
                  onEmailSent={handleClientEmailSent}
                />
              </div>

              <div style={{ marginLeft: "auto" }} className="rp-pdf-download-wrap">
                {loading ? (
                  <span
                    className="rp-bottom-nav-btn"
                    style={{ backgroundColor: "#2563C0", color: "white", padding: "10px 20px", display: "inline-block", borderRadius: "8px", fontWeight: 600 }}
                  >
                    Loading document...
                  </span>
                ) : (
                  <a
                    href={url || undefined}
                    download={`${currentViewingReport.Client.Name}-${currentViewingReport.ReportedDate}.pdf`}
                    className="rp-bottom-nav-btn hover-trigger"
                    style={{ backgroundColor: "#2563C0", color: "white", textDecoration: "none", padding: "10px 20px", display: "inline-flex", borderRadius: "8px", fontWeight: 600, boxShadow: "0 4px 12px rgba(37,99,192,0.2)" }}
                  >
                    Download PDF
                  </a>
                )}
              </div>
            </>
          )}
        </BlobProvider>
      </div>
      <SubmitReportSuccess
        show={showSuccessModal}
        onHide={handleCloseSuccessModal}
        successMessage="Report saved successfully"
        isReportSaved={isReportSaved}
        isExitFlow={false}
      />
      <SubmitReportSuccess
        show={showExitModal}
        onHide={handleCloseExitModal}
        successMessage=""
        isReportSaved={isReportSaved}
        isExitFlow={true}
      />
    </Container>
  );
};
